import React from "react";
import { Select } from "antd";
import { getTemplateList } from "api/template.api";
import { useEffect, useState } from "react";
import { debounce } from "lodash";
import { useAppSelector } from "hooks/reduxHooks";

type TemplateOption = {
  label: string;
  value: number;
  details: any; // replace `any` with actual template type if you have it
};

const TemplateListDropdown = (props: any) => {
  const [templateList, setTemplateList] = useState<TemplateOption[]>([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState<number>(1);
  const [loadingMore, setLoadingMore] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const emailTemplateRefresh = useAppSelector((state) => state.refresh.emailTemplateRefresh);
  const handlePopupScroll = debounce(async (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    const isNearBottom = scrollHeight - (scrollTop + clientHeight) < 50;

    if (isNearBottom && !loadingMore && hasMore) {
      setLoadingMore(true);
      setPage(page + 1);
      setLoadingMore(false);
    }
  }, 200);

  useEffect(() => {
    getTemplateListFromServer();
  }, [page, emailTemplateRefresh]);

  const getTemplateListFromServer = () => {
    setLoading(true);
    getTemplateList(page, props.type).then(
      (templateList: any) => {
        const parsedTemplateList = templateList.results
          .map((template: any) => {
            return {
              label: template.name,
              value: template.id,
              details: template,
            };
          });
        setLoading(false);
        setTemplateList((prev) => [...prev, ...parsedTemplateList]);
        if (page >= templateList.count / 10) {
          setHasMore(false);
        }
      },
      () => {
        setLoading(false);
        setTemplateList([]);
      }
    );
  };

  return (
    <Select
      loading={loading}
      placeholder="Select Template"
      className={!loading ? "min-w-32" : ""}
      {...props}
      options={templateList}
      dropdownStyle={{ maxHeight: 250, overflowY: "auto" }}
      onPopupScroll={handlePopupScroll} // Detect scroll inside dropdown
      dropdownRender={(menu) => (
        <div style={{ maxHeight: 250, overflowY: "auto" }} onScroll={handlePopupScroll}>
          {menu}
        </div>
      )}
    ></Select>
  );
};

export default TemplateListDropdown;
